// ============================================================================
// `/time` has two landing pages, because it has two audiences.
//
// HR, finance and executives land on the EXCEPTION QUEUE — the spec's rule that
// the landing page is what is anomalous, not a menu.
//
// An account manager lands on HOURS. Sending them to the exception queue would
// be a menu entry to a screen full of other people's problems that they cannot
// action, which is worse than no menu entry at all.
// ============================================================================

import { AmHours, useIsAmSide } from './am-views';
import { TimeConsole } from './time-console';
import { HoursLinksPage } from './hours-links';
import { useAuth } from '../../shared/auth';
import { isSalesSeat } from '../../shared/role-gates';

// Sales sees one Time & Labor tab, Hours links (Ben, 2026-10-23: "Sales helps Ops"),
// so that is where /time lands for them.
export function TimeLanding() {
  const { profile } = useAuth();
  const amSide = useIsAmSide();
  if (isSalesSeat(profile?.role ?? 'none')) return <HoursLinksPage />;
  return amSide ? <AmHours /> : <TimeConsole />;
}
